import Alpine from 'alpinejs'

/**
 * Initializes alpine.js
 */
export function initializeAlpine() {
    window.Alpine = Alpine

    Alpine.start()
}
